import { UsuarioComercioApi as Api } from "./usuario-comercio.api";

export class UsuarioComercioFacade {
  static countWithFilter(filter) {
    return Api.countWithFilter(filter);
  }

  static create(model) {
    const creationData = this._toDto(model);

    return new Promise((resolve, reject) => {
      Api.create(creationData)
        .then(response => {
          this._toModel(response.data)
            .then(model => {
              resolve({ data: model });
            })
            .catch(error => reject(error));
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  static deleteById(id) {
    return Api.delete(id);
  }

  static getListWithFilter(filter) {
    return new Promise((resolve, reject) => {
      Api.getListWithFilter(filter)
        .then(response => {
          const list = response.data;

          return Promise.all(list.map(dto => this._toModel(dto)))
            .then(modelList => {
              return resolve({ data: modelList });
            })
            .catch(error => reject(error));
        })
        .catch(error => {
          return reject(error);
        });
    });
  }

  static update(model) {
    const updateData = this._toDto(model);

    return new Promise(resolve => {
      Api.update(updateData).then(response => {
        this._toModel(response.data).then(model => {
          resolve({ data: model });
        });
      });
    });
  }

  static _toDto(model) {
    return {
      id: model.id,
      mail: model.mail,
      clave: model.clave,
      comercioID: model.comercio?.id,
      comercioNombre: model.comercio?.nombre
    };
  }

  static async _toModel(dto) {
    return {
      id: dto.id,
      mail: dto.mail,
      clave: dto.clave,
      comercio: { id: dto.comercioID, nombre: dto.comercioNombre }
    };
  }
}
